import { ReactComponent as Cordova } from "../../../../../../assets/images/imgly/cordova.svg";
import { ReactComponent as Flutter } from "../../../../../../assets/images/imgly/flutter.svg";
import { ReactComponent as Ionic } from "../../../../../../assets/images/imgly/ionic.svg";
import { ReactComponent as ReactNative } from "../../../../../../assets/images/imgly/reactnative.svg";
import * as React from 'react';
export default {
  Cordova,
  Flutter,
  Ionic,
  ReactNative,
  React
};